<template>
    <div>
        <membership-orders></membership-orders>
    </div>
</template>
<script>
    import MembershipOrders from './partials/MembershipOrders';
    export default {
        data() {
            return {

            }
        },
        components: {
            'membership-orders': MembershipOrders
        }
    }
</script>
<style lang="scss" scoped>

</style>